export default __webpack_public_path__ + "static/media/Pc.e03fb9b1.png";